'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = memoWithDisplayName;

var _react = require('react');

/**
 * Workaround for a React bug where attaching `displayName` to a `memo`'d component doesn't result
 * in that `displayName` being recognized by React (e.g. in Dev Tools).
 *
 * @param {string} displayName The `displayName` to attach to the given `Component`
 * @param {Function} Component A function component to memoize
 */
function memoWithDisplayName(displayName, Component) {
  Component.displayName = displayName;
  return (0, _react.memo)(Component);
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/utils/memoWithDisplayName.js
// module id = 12
// module chunks = 177